const publicFilters = localStorage.getItem('publicFilters')

export const defaultObjectHierarchy = [
  {
    id: 'emitter'
  },
  {
    id: 'infrastructure'
  },
  {
    id: 'transportbase'
  },
  {
    id: 'route',
    children: [
      {
        id: 'collectingloop',
        parents: ['route']
      },
      {
        id: 'removaltrip',
        parents: ['route']
      },
      {
        id: 'transfer',
        parents: ['route']
      }
    ]
  },
  {
    id: 'exportDirections',
    children: [
      {
        id: 'flow',
        parents: ['exportDirections']
      },
      {
        id: 'source',
        parents: ['exportDirections']
      }
    ]
  },
  {
    id: 'info'
  },
  {
    id: 'streaminfo'
  },
  {
    id: 'containerplatform'
  },
  {
    id: 'building'
  },
  {
    id: 'zonegroup'
  }
]

export const defaultObjectItems = {
  emitter: {
    count: -1,
    objects: [],
    objectsInfo: {}
  },
  infrastructure: {
    count: -1,
    children: [],
    objectsInfo: {},
    childrenInfo: {}
  },
  streaminfo: {
    count: -1,
    children: [],
    objectsInfo: {},
    childrenInfo: {}
  },
  info: {
    count: -1,
    children: [],
    objectsInfo: {},
    childrenInfo: {}
  },
  containerplatform: {
    count: -1,
    children: [],
    objectsInfo: {},
    childrenInfo: {}
  },
  transportbase: {
    count: -1,
    objects: [],
    objectsInfo: {}
  },
  building: {
    count: -1,
    objects: [],
    objectsInfo: {}
  },
  flow: {
    count: -1,
    objects: [],
    objectsInfo: {}
  },
  source: {
    count: -1,
    objects: [],
    objectsInfo: {}
  },
  collectingloop: {
    count: -1,
    objects: [],
    objectsInfo: {}
  },
  removaltrip: {
    count: -1,
    objects: [],
    objectsInfo: {}
  },
  transfer: {
    count: -1,
    objects: [],
    objectsInfo: {}
  },
  zonegroup: {
    count: -1,
    children: [],
    objectsInfo: {},
    childrenInfo: {}
  }
}

export const defaultObjectMapData = {
  emitter: null,
  building: null,
  infrastructure: null,
  route: null,
  source: [],
  flow: [],
  info: null,
  streaminfo: null,
  borders: null,
  zonegroup: null,
  admterritory: null,
  containerplatform: null,
  transportbase: null,
  zoneGroupColors: null,
  infrastructureColors: null,
  streaminfoRoute: null
}
export const default3DObjectMapData = {
  infrastructure: null,
  source: [],
  flow: [],
  fullFlows: [],
  borders: null,
  territories: null
}

export const defaultObjectMapRequestTime = {
  emitter: null,
  building: null,
  infrastructure: null,
  route: null,
  source: null,
  flow: null,
  info: null,
  streaminfo: null,
  borders: null,
  zonegroup: null,
  zones: null,
  containerplatform: null,
  transportbase: null
}

export default {
  objectsPeriod: null,
  objectSelected: null,
  objectDetailsSelected: null,
  objectDetailsInfo: null,
  objectStaticInfo: [],
  object3DMapData: JSON.parse(JSON.stringify(default3DObjectMapData)),

  /**
   * Иерархия слоев
   * {
   *   id, - идентификатор слоя
   *   children, - массив объектов дочерних слоев
   *   parents - массив идентификаторов родителй
   * }
   */
  objectLayers: JSON.parse(JSON.stringify(defaultObjectHierarchy)),

  /**
   * Список объектов слоя
   */
  objectLayerItems: JSON.parse(JSON.stringify(defaultObjectItems)),

  /**
   * Настройки слоя
   */
  objectLayerSettings: {},
  objectMapData: JSON.parse(JSON.stringify(defaultObjectMapData)),
  objectMapRequestTime: JSON.parse(JSON.stringify(defaultObjectMapData)),
  objectPublicFilters: publicFilters ? JSON.parse(publicFilters) : {},
  objectMapCacheUpdated: null,
  forceClosePanels: null,
  forceDefaultVisibilityPanels: null,
  forceObjectMapCenter: null,
  forceObjectMapBounds: null,
  objectMapParams: null,
  objectExactMapParams: null,
  objectContainerTypes: null,
  objectShowContainerRoute: false,
  objectLoadingData: 0,

  objectZoneGroupMode: false,
  objectWastes: [],
  objectWasteSelected: 'all',
  objectTreatmentSelected: '',

  objectFilterList: [],
  objectFilters: {
    text: ''
  },
  objectfilterDict: null,

  territoryColors: [
    {
      id: 'outcomes',
      name: 'Удельные расходы (руб./тонну)'
    },
    {
      id: 'mass',
      name: 'Масса (тыс. тонн)'
    },
    {
      id: 'useful',
      name: 'Доля отобранных полезных фракций'
    }
  ],
  objectLayerNames: {
    emitter: 'отходообразователи',
    building: 'здания',
    containerplatform: 'контейнерные площадки',
    source: 'источники потоков',
    flow: 'потоки',
    infrastructure: 'объекты инфраструктуры',
    route: 'маршруты',
    transportbase: 'транспортные базы',
    territories: 'группы зон'
  },
  objectLayerTypes: {
    emitter: 'emitter',
    flow: 'flow',
    source: 'source',
    transportbase: 'transportbase',
    collectingloop: 'collectingloop',
    removaltrip: 'removaltrip',
    transfer: 'transfer',
    infrastructure: 'infrastructure',
    zonegroup: 'zonegroup',
    containerplatform: 'containerplatform',
    building: 'building'
  },

  /**
   * Словарь для хранения скрытых полей
   */
  fieldsControlDict: null
}



// WEBPACK FOOTER //
// ./src/store/objects/defaults.js